
import actionType from "./actionTypes";
import axios from "axios";
import { hideIsLoading, showIsLoading, viewAPIStatusChange, refreshApiService, viewRequestInfo } from "../common/action";
import { toast } from "react-toastify";
import URL from "../../assets/config";

export const InitialfedexTrack = () => dispatch => {
  
  dispatch({
    type: actionType.INITIAL_FEDEX_TRACK,
   
  })
};

export const getFacilityList = token => dispatch => {
  toast.dismiss();
  console.log("I am testing registered list:................1111")

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.employee.GET_FACILITY_LIST,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
  axios(config).then((res) => {
    console.log("I am testing registered list:...............22222.",res)
    dispatch(hideIsLoading());
      if (res.status === 200) {
        console.log("I am testing registered list:...............3333333333.",res.data)
        dispatch({
          type: actionType.GET_FACILITY_LIST_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_FACILITY_LIST_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
     dispatch(hideIsLoading());
     if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getFacilityList ))
   }
     dispatch({
       type: actionType.GET_FACILITY_LIST_FAILURE,
       error: error
     });
   });
};
 
  
export const getNewFacilityList = token => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.employee.GET_NEW_FACILITY_LIST,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch({
          type: actionType.GET_NEW_FACILITY_LIST_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_NEW_FACILITY_LIST_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getNewFacilityList ))
   }
     dispatch({
       type: actionType.GET_NEW_FACILITY_LIST_FAILURE,
       error: error
     });
   });
};
  


export const viewBAAImage = (  token, id) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.employee.GET_VIEW_DETAILS + id,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch({
          type: actionType.GET_BAA_IMAGE_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_BAA_IMAGE_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(viewBAAImage, id ))
   }
     dispatch({
       type: actionType.GET_BAA_IMAGE_FAILURE,
       error: error
     });
   });
};



export const facilityRegApprove = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.employee.FACILITY_REG_STATUS_CHANGE,
    data:payload,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
   axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch(getFacilityList(token));
        dispatch({
          type: actionType.FACILITY_REG_STATUS_CHANGE_SUCCESS,
          message: res.data.message
        });
        toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch({
        type: actionType.FACILITY_REG_STATUS_CHANGE_FAILURE,
        error: res.data.message
      })
      toast.success(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(facilityRegApprove, payload ))
   }
     dispatch({
       type: actionType.FACILITY_REG_STATUS_CHANGE_FAILURE,
       error: error
     });
     toast.success(error)
   });
};




export const changeRequestStatus = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());
  

  const config = {
    method: 'post',
    url: URL.employee.FACILITY_REQUEST_STATUS_CHANGE,
    data:payload,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
   axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch(getNewFacilityList(token));
        dispatch({
          type: actionType.FACILITY_REQUEST_STATUS_CHANGE_SUCCESS,
          message: res.data.message
        });
        toast.success(res.data.message)
      
    } else if (res.status === 206) {
      dispatch({
        type: actionType.FACILITY_REQUEST_STATUS_CHANGE_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(changeRequestStatus, payload ))
   }
     dispatch({
       type: actionType.FACILITY_REQUEST_STATUS_CHANGE_FAILURE,
       error: error
     });
     toast.error(error.response.data.message)
   });
};

export const getRecordReqList = (token, userType, userId )=>dispatch=>{
  toast.dismiss();

  dispatch(showIsLoading());
  const config = {
    method: 'get',
    url: URL.employee.RECORD_REQ_LIST,
    params : {
      role : userType, 
      id : userId
    },
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
   axios(config).then((res) => {
    dispatch(hideIsLoading());
    
    dispatch(viewAPIStatusChange());

    if (res.status === 200) {
      dispatch({
        type: actionType.RECORD_REQ_LIST_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch(hideIsLoading());
      dispatch({
        type: actionType.RECORD_REQ_LIST_FAILURE,
        error: res.data.message
      })
    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getRecordReqList, userType, userId ))
   }
    dispatch({
      type: actionType.RECORD_REQ_LIST_FAILURE,
      error: error 
    })

   });

};




export const finalcost = (token, payload, userType, userId ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.employee.FINAL_COST,
    data:payload,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
   axios(config).then((res) => {
//    dispatch(chargeFinalCost(payload.requestId, token));
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch(getRecordReqList(token, userType, userId))

        dispatch({
          type: actionType.FINAL_COST_SUCCESS,
          payload : res.data,
          message: res.data.message
        });
        toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch({
        type: actionType.FINAL_COST_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(finalcost, payload, userType, userId ))
   }
     dispatch({
       type: actionType.FINAL_COST_FAILURE,
       error: error
     });
     toast.error(error.response.data.message)
   });
};


export const assignReqStatus = (token, formData, userType, userId) => dispatch => {
  toast.dismiss();


 
  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.employee.ASSIGN_EMPLOYEE_STATUS,
    data:formData,
    headers: {
      //'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
   axios(config).then((res) => {
   
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch(getRecordReqList(token, userType, userId));
        dispatch({
          type: actionType.ASSIGN_EMPLOYEE_STATUS_SUCCESS,
          payload : res.data,
          message: res.data.message
        });
        toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch({
        type: actionType.ASSIGN_EMPLOYEE_STATUS_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(assignReqStatus, formData, userType, userId ))
   }
     dispatch({
       type: actionType.ASSIGN_EMPLOYEE_STATUS_FAILURE,
       error: error
     });
     toast.error(error.response.data.message)
   });
};


export const fedexTrackingApi = (token, payload ,)=>dispatch=>{
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.employee.FEDEX_TRACKING,
    data:payload,
    headers: {
      'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
    }   };
   axios(config).then((res) => {

    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(downloadStatusChange())
      dispatch( faxStatusChange())

       dispatch({
        type: actionType.FEDEX_TRACKING_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
 
      dispatch({
        type: actionType.FEDEX_TRACKING_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)

    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(fedexTrackingApi, payload ))
   }
     dispatch({
       type: actionType.FEDEX_TRACKING_FAILURE,
       error: error
     });
     toast.error(error.message)

   });

};





export const checkFaxStatus = (token,payload)=>dispatch=>{
  toast.dismiss();

  dispatch(showIsLoading());
  dispatch(downloadStatusChange());
  const config = {
    method: 'post',
    url: URL.employee.CHECK_FAXSTATUS,
    params:payload,
    headers: {
      'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
    }   };
   axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(downloadStatusChange())
        dispatch(fedexStatusChange())
       dispatch({
        type: actionType.CHECK_FAXSTATUS_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
     // toast.success(res.data.message)
    } else if (res.status === 206) {
 
      dispatch({
        type: actionType.CHECK_FAXSTATUS_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)

    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(checkFaxStatus, payload ))
   }
     dispatch({
       type: actionType.CHECK_FAXSTATUS_FAILURE,
       error: error
     });
     toast.error(error.message)

   });

};



export const downloadRecords = (token, id )=>dispatch=>{
  toast.dismiss();

  dispatch(showIsLoading());
 
  const config = {
    method: 'get',
    url:URL.employee.DOWNLOAD_RECORDS,
    params:id,
     headers: {
      'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
    }   };
   axios(config).then((res) => {

    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(faxStatusChange())
        dispatch(fedexStatusChange())
        dispatch({
        type: actionType.DOWNLOAD_RECORDS_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
 
      dispatch({
        type: actionType.DOWNLOAD_RECORDS_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
    
   }).catch(error => {
    dispatch(hideIsLoading());

    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(downloadRecords, id ))
   }
     dispatch({
       type: actionType.DOWNLOAD_RECORDS_FAILURE,
       error: error
     });
     toast.error(error.message)
    });

};

export const faxResendApi = (token,payload)=>dispatch=>{
  toast.dismiss();

  let viewData = {
    "requestId" : payload.requestInfoId
  }
  dispatch(showIsLoading());
  dispatch(downloadStatusChange());
  const config = {
    method: 'post',
    url: URL.employee.FAX_RESEND,
    params:payload,
    headers: {
      'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
    }   };
   axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());
     dispatch(viewRequestInfo(token, viewData ));
       dispatch({
        type: actionType.FAX_RESEND_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
 
      dispatch({
        type: actionType.FAX_RESEND_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)

    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(faxResendApi, payload ))
   }
     dispatch({
       type: actionType.FAX_RESEND_FAILURE,
       error: error
     });
     toast.error(error.message)

   });

};


export const getFacilityemrList = (token)=>dispatch=>{
  toast.dismiss();

 
  dispatch(showIsLoading());
 
  const config = {
    method: 'get',
    url: URL.employee.FACILITY_EMR_LIST,
    
    headers: {
      'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
    }   };
  
   axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());
   
       dispatch({
        type: actionType.FACILITY_EMR_LIST_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
     // toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch(hideIsLoading());
      dispatch({
        type: actionType.FACILITY_EMR_LIST_FAILURE,
        error: res.data.message
      })
     // toast.error(res.data.message)

    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getFacilityemrList ))
   }
     dispatch({
       type: actionType.FACILITY_EMR_LIST_FAILURE,
       error: error
     });
    // toast.error(error.message)

   });

};

    
export const refreshStatusFalse = () => {
  return{
    type:actionType.REFRESH_COST_STATUS_FALSE,
 }
};



export const finalCostForView = (token,payload, userType, userId)=>dispatch=>{
  toast.dismiss();

 
  dispatch(showIsLoading());
 
  const config = {
    method: 'post',
    url: URL.employee.FINALCOST_FOR_VIEW,
    data:payload,
    headers: {
      
      "Authorization": 'bearer  ' + token,
    }   };
  
   axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(getRecordReqList(token, userType, userId));
      dispatch(hideIsLoading());
   
       dispatch({
        type: actionType.FINALCOST_FOR_VIEW_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
     // toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch(hideIsLoading());
      dispatch({
        type: actionType.FINALCOST_FOR_VIEW_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)

    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(finalCostForView, payload, userType, userId ))
   }
     dispatch({
       type: actionType.FINALCOST_FOR_VIEW_FAILURE,
       error: error
     });
    // toast.error(error.message)

   });

};


export const adminEditCostDetails = (token, payload, userType, userId ) => dispatch => {
  toast.dismiss();


  dispatch(showIsLoading());

  const config = {
    method: 'post',
    data:payload,
    url: URL.admin.ADMIN_EDIT_COST_DETAILS,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
       if (res.status === 200) {
        dispatch(getRecordReqList(token, userType, userId));
        dispatch({
          type: actionType.ADMIN_EDIT_COST_DETAILS_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
        toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch({
        type: actionType.ADMIN_EDIT_COST_DETAILS_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
  }).catch(error => {
     dispatch(hideIsLoading());
     if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(adminEditCostDetails, payload, userType, userId ))
   }
     dispatch({
       type: actionType.ADMIN_EDIT_COST_DETAILS_FAILURE,
       error: error
     });
    toast.error(error.response.data.message)
   });
};

export const downloadStatusChange = () => dispatch => {
   dispatch({
    type: actionType.DOWNLOAD_STATUS_CHANGE,
  })
 
};

export const faxStatusChange = () => dispatch => {
  
  dispatch({
    type: actionType.FAX_STATUS_CHANGE,
  })
  
};

export const fedexStatusChange = () => dispatch => {
  
  dispatch({
    type: actionType.FEDEX_STATUS_CHANGE,
  })
  
};

